import React from "react";
import { Outlet } from "react-router-dom";

const Editor = () => (
  <main className="editor" aria-label="Editor">
    <Outlet />
  </main>
);

export default Editor;